import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'
import { pushDataLayer } from 'utils/push-data-layer'

import { documents } from '../documents'

import * as S from './styles'

const Guidelines: FC = memo(() => (
  <S.Section $bg="medium">
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium">
            Nossas{' '}
            <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-contrast)">
              Diretrizes
            </Text>
          </Text>
        </S.TitleWrapper>

        <S.Lead>
          <Text color="var(--colors-neutral-text-default)">
            Cuidamos para que as nossas diretrizes sejam incorporadas e vividas diariamente, dentro e fora da CashMe.
            <br />
            Clique nos cards e conheça as nossas Políticas e Normas:
          </Text>
        </S.Lead>

        <S.List>
          {documents.map(({ id, title, href, dataLayer }) => (
            <S.Item key={id}>
              <Text size="body2" color="var(--colors-neutral-text-default)">
                {title}
              </Text>

              <S.Download
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Baixar ${title}`}
                onClick={() => pushDataLayer(dataLayer)}
              >
                Baixar
              </S.Download>
            </S.Item>
          ))}
        </S.List>
      </Col>
    </Grid>
  </S.Section>
))

Guidelines.displayName = 'Guidelines'

export default Guidelines
